import { render, staticRenderFns } from "./DoughnutChartIngresso.vue?vue&type=template&id=19830fb0"
import script from "./DoughnutChartIngresso.vue?vue&type=script&lang=js"
export * from "./DoughnutChartIngresso.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports